import { apiClient } from '@borradh-workspace/api-client';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

const reviewLinkKey = ['integrations', 'google-review-link'] as const;
export function useReviewLink() {
  return useQuery({
    queryKey: reviewLinkKey,
    queryFn: () =>
      apiClient.get<{ reviewUrl: string | null }>(
        'integrations/google-review-link'
      ),
  });
}
export function useNormalizeReviewLink() {
  return useMutation({
    mutationFn: (link: string) =>
      apiClient.post<{ reviewUrl: string }>(
        'integrations/google-review-link/normalize',
        { link }
      ),
  });
}
export function useSaveReviewLink(onSaved: () => void) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (reviewUrl: string | null) =>
      apiClient.put<{ reviewUrl: string | null }>(
        'integrations/google-review-link',
        { reviewUrl }
      ),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: reviewLinkKey });
      onSaved();
      toast.success('Google review link saved');
    },
    onError: () =>
      toast.error('Could not save the review link. Please try again.'),
  });
}
